module.exports = __webpack_public_path__ + "static/ms-teams-03dc4b1f4b36fa4b5ebe06a6905b43eb.png";